
// constants
import * as ACTIONS from './constants';

// functions
import { getAllCardTemplates } from '../services/templatesService';
import { equal } from '../services/jsonEqualityService';

export const getCardTemplates = () => (dispatch, getState) => {
  const state = getState();
  return getAllCardTemplates(state.user.userGuid)
    .then((templates) => {
      if(!equal(templates, state.eventFeed.cardTemplates, { ignoreArrayOrder: true })) {
        dispatch({ type: ACTIONS.UPDATE_CARD_TEMPLATES, payload: templates })
      }
    })
    .catch(() =>
      dispatch({
        type: ACTIONS.UPDATE_EVENTS,
        payload: [
          {
            type: 'ErrorNotification',
            state: true,
            payload: { error: 'Something went wrong' }
          }
        ]
      }));
}





// WEBPACK FOOTER //
// ./src/actions/cardTemplates.js